import React from 'react'
import CallTrackApi from '../Activity_Track/CallTrackApi';

function Brokaragecalculator() {
    function iframe() {
        return {
            __html: '<iframe src="brokarage-calculator.html" width="100%" height="2500px" style="border:0; overflow:hidden;"></iframe>'
        }
    }
  CallTrackApi("Brokerage Calculator",window.location.href);

    return (
        <>
            <div>
                <div dangerouslySetInnerHTML={iframe()} />
            </div>
        </>
    );
}

export default Brokaragecalculator